const API_BASE = process.env.REACT_APP_API_URL || '';

export async function login(email, password) {
  const response = await fetch(`${API_BASE}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, password })
  });
  
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Login failed');
  }
  
  return response.json();
}

export async function logout() {
  const response = await fetch(`${API_BASE}/auth/logout`, {
    method: 'POST',
    credentials: 'include'
  });
  
  if (!response.ok) {
    throw new Error('Logout failed');
  }
  
  return response.json();
}

export async function getCurrentUser() {
  const response = await fetch(`${API_BASE}/auth/me`, {
    credentials: 'include'
  });
  
  if (!response.ok) {
    if (response.status === 401) {
      return null;
    }
    throw new Error('Failed to get current user');
  }
  
  const data = await response.json();
  return data.user;
}

export async function getGoogleConfig() {
  const response = await fetch(`${API_BASE}/auth/google/config`, {
    credentials: 'include'
  });
  
  if (!response.ok) {
    return { clientId: null, enabled: false };
  }
  
  return response.json();
}

export async function loginWithGoogle(credential) {
  const response = await fetch(`${API_BASE}/auth/google`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ credential })
  });
  
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Google login failed');
  }
  
  return response.json();
}
